// **********************************************************************************


import Button from "../../../../components/bases/button/button.js";

import closeparam from "./assets/closeparam.png"
import openparam from ".//assets/openparam.png"



import imgstats from "./assets/stats.png"
import imgam from "./assets/am.png"
import imgmenu from "./assets/menu.png"
import imgerrors from "./assets/errors.png"

import OptionsMenu from "./optionsmenu.js";
import SubtitleErrors from "../subtitleerrors/subtitleerrors.js";

import AssetsManager from "../assetsmanager/assetsmanager.js";


import Tooltip from "../../../../components/bases/tooltips/tooltip.js";

import getText from "../../../../utils/language.js";
import { GlobalContext } from "../../../../utils/globalprovider.js";
import AppInfo from "../appinfos/appinfos.js";
import "./appmediaassets.css"
import React from "react";

import ToolsBar from "../../../../components/bases/toolsbar/toolsbar.js";
import { configurations_getDefaultParams } from "../../../../utils/configurations.js";
import { setCurrentErrorsOptions } from "../../../../utils/software.js";





class AppMediaAssets extends React.Component
{

    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        this.state = {
            open: false,

        displaytab: 1,
        toolsbarkey: "MA",
        defaultOption:"",
        toolsbar:
          { 
            height: 20,


                    items: [
                      {img: imgam ,type:"button", disable:false,fr:"Media Assets",en:"Media Assets", nochangecolor:false, key:{key:"MA", cat:"shortcut"}},
                      {type:"space"},
                      {img: imgmenu ,type:"button", disable:false,fr:"Boîte à outils",en:"ToolsBox", nochangecolor:false, key:{key:"MENU", cat:"shortcut"}},
                      {type:"space"},
                      {img: imgerrors ,type:"button", disable:this.props.mode==="transcription",fr:"Erreurs",en:"Errors", nochangecolor:false, key:{key:"ERRORS", cat:"shortcut"}},
                      {type:"space"},
                      {img: imgstats ,type:"button", disable:false,fr:"Statistiques",en:"Statistics", nochangecolor:false, key:{key:"STATS", cat:"shortcut"}},
                    ],
                },

             
        }

        this.onClickOnMenu = this.onClickOnMenu.bind(this);
        this.onClickToolsBar = this.onClickToolsBar.bind(this);
        this.optionMenuRef = React.createRef();
        

    }

    displayOption(menu,option)
    {

        if (this.state.displaytab === 2)
        {
            if ((this.optionMenuRef) && (this.optionMenuRef.current)){
              this.optionMenuRef.current.setCurrentOption(menu,option);
              return;
            }
        }
               
        this.setState ({displaytab:2,open:true, defaultOption: option,toolsbarkey: "MENU"})
    }

    closeAppMediaAsset()
    {
        this.setState({open: false});
    }
  
    onClickOnMenu()
    {
        this.setState({open: !this.state.open, defaultOption:""});
    }

    onClickToolsBar(datas)
    {
        switch (datas.cat)
        {
        case "shortcut":
            switch (datas.key)
            {
            case "MA":
                this.setState({displaytab: 1, toolsbarkey: datas.key, defaultOption:""})
                break;
            case "MENU":
                this.setState({displaytab: 2, toolsbarkey: datas.key, defaultOption:""})
                break;
            case "STATS":
                this.setState({displaytab: 3, toolsbarkey: datas.key, defaultOption:""})
                break;
            case "ERRORS":
                this.setState({displaytab: 4, toolsbarkey: datas.key, defaultOption:""})
                break;
            }
        }
    }
    
    render()
    {

        var tipmenu= getText(3,0, this.context.language);

        var style1 = {display: 'none'}
        var style2 = {display: 'none'}
        var style3 = {display: 'none'}
        var style4 = {display: 'none'}
        switch (this.state.displaytab)
        {
            case 1: style1 = {display: 'block'}; break;
            case 2: style2 = {display: 'block'}; break;
            case 3: style3 = {display: 'block'}; break;
            case 4: style4 = {display: 'block'}; break;
        }



        //divMAParamSettingRightOpen
        //divMAParamSettingClose

        

        //divMAParamSettingOpenMenu
        //divParamSettingRightClose


        //divMAParamSettingOpen
        //divMAParamSettinClose


        var stylediv ={display:'block', height:"90%"};




        var divchildren = "divMAParamSettingOpen";
        var div1  = "divMAParamSettingRightOpen"
        var div2 =  "divMAParamSettingOpenMenu";

        if (this.state.toolsbarkey == "ERRORS") 
        {
            divchildren = "divMAParamSettingOpenSmall";
            div1  = "divMAParamSettingRightOpenSmall"
        }

        if (this.state.toolsbarkey == "MENU") 
        {
            divchildren = "divMAParamSettingOpenMedium";
            div1  = "divMAParamSettingRightOpenMedium"
        }


        var menuoption = (
                <div className="divMAParamSettingContent" style={ style2 }>
                            <OptionsMenu
                                pjid = {this.props.pjid}
                                defaultOption = {this.state.defaultOption}
                                saveSubtitles = {this.props.saveSubtitles}
                                codatas = {this.props.codatas}
                                stparams = {this.props.stparams}
                                onaction = {this.props.onaction}
                                key = {this.props.refreshKey}
                                ref = {this.optionMenuRef}
                                type = {this.props.mode}
                                subtitles = {this.props.subtitles}
                                current = {this.props.current}
                                timecodeasset = {this.props.timecodeasset}
                                timecode = {this.props.timecode}
                                mediaassetref = {this.props.mediaassetref}
                                st_list_ref  = {this.props.st_list_ref}
                                st_edit_ref = {this.props.st_edit_ref}


                            />

                        
                </div>)

        var menuerror = (
                        <div className="divMAParamSettingContent" style={ style4 }>
                            
                            <SubtitleErrors 
                                visible = {(this.state.open) && (this.state.toolsbarkey == "ERRORS")}
                                stparams = {this.props.stparams}
                                subtitles = {this.props.subtitles}
                                current = {this.props.current}
                                onClick = {this.props.onClickOnErrorSubtitle}
                                timecodeasset = {this.props.timecodeasset}
                            />
                        </div>)


        var imgmenu = closeparam;
        if (!this.state.open)
        {
            divchildren = "divMAParamSettingClose";
            div1 = "divMAParamSettingRightClose";
            div2 = "divMAParamSettingOpenMenu";
            stylediv ={display:'none'};
            menuoption=(<></>)
            menuerror =(<></>)
            imgmenu = openparam;
            

        }

        

            return (
                <div className="divMAFullParamSetting" >

                            
                            <div className={div1}>
                    
                                <div className={div2}>
                                    <Tooltip text= {tipmenu} align="left">
                                    <Button width="28px" height="28px" image={imgmenu} border={false} disable={false} onClick={this.onClickOnMenu}/>
                                    </Tooltip>
                                </div>
                            

                                <div style= {stylediv}>

                                    <ToolsBar 
                                        onClick={this.onClickToolsBar} 
                                        toolsbar={this.state.toolsbar} 
                                        currentKey = {this.state.toolsbarkey}/>
                            
                                    <div className="divMAParamSettingContent" style={ style1 } >

                                        Media Assets


                                        <AssetsManager 
                                            tree = {this.props.tree}
                                            pjid={this.props.pjid} 
                                            mode = {this.props.mode}
                                            onCancelKeyboardEvent = {this.props.onCancelKeyboardEvent}
                                            onClick = {this.props.onClick}
                                            onChange = {this.props.onChange}
                                            ref={this.props.mediaassetref}/>
                                    </div>

                                    {menuoption}
                                    <div className="divMAParamSettingContent" style={ style3 }>
                                        Stats.
                                        <AppInfo value = {this.props.appInfos}/>
                                    </div>
                                    {menuerror}


                                </div>
                        </div>

                            <div className={divchildren}>
                                {this.props.children}
                            </div>



                </div>
                    

            
            )
        }
};


AppMediaAssets.defaultProps = 
{ 
    codatas : {coid: -1},
    stparams: configurations_getDefaultParams(25,1),
    subtitles:[],
    current:1,
}


export default AppMediaAssets;

